import slugify from "slugify";
import { idKeyByType, pathByType } from "./autocompletev2";

const NAMESPACE = "ct_";


function _getKey(key) {
  return `${NAMESPACE}${key}`;
}

function set(key, value) {
  try {
    const data = JSON.stringify(value);
    localStorage.setItem(_getKey(key), data);
  } catch (e) {
    console.error("Erro ao salvar no localStorage:", e, { key, value });
  }
}

function get(key, fallback = null) {
  try {
    const data = localStorage.getItem(_getKey(key));
    return data ? JSON.parse(data) : fallback;
  } catch (e) {
    console.error("Erro ao recuperar do localStorage:", e, { key });
    return fallback;
  }
}

function append(key, value, maxLength = 100, uniqueField = null, nestedKey = null) {
  let arr = get(key, []);
  if (!Array.isArray(arr)) {
    arr = [];
  }

  if (uniqueField) {
    if (nestedKey) {
      arr = arr.filter(item => item?.[nestedKey]?.[uniqueField] !== value?.[nestedKey]?.[uniqueField]);
    } else {
      arr = arr.filter(item => item?.[uniqueField] !== value?.[uniqueField]);
    }
  }

  arr.push(value);
  if (arr.length > maxLength) {
    arr = arr.slice(-maxLength);
  }
  set(key, arr);
}

function remove(key, value, uniqueField = null, nestedKey = null) {
  let arr = get(key, []);
  if (!Array.isArray(arr)) {
    return;
  }

  let filtered;
  if (uniqueField) {
    if (nestedKey) {
      filtered = arr.filter(item => item?.[nestedKey]?.[uniqueField] !== value?.[uniqueField]);
    } else {
      filtered = arr.filter(item => item?.[uniqueField] !== value?.[uniqueField]);
    }
  } else {
    const valueStr = JSON.stringify(value);
    filtered = arr.filter(item => JSON.stringify(item) !== valueStr);
  }
  set(key, filtered);
}

function resolveLocationCode(place = {}) {
  const uf = String(place.uf || place.stateUf || '').trim();
  if (uf && uf.toUpperCase() !== 'ND') {
    return uf.toUpperCase();
  }

  const countryAcronym = String(
    place.ac || place.countryAcronym || place.countryCode || ''
  ).trim();
  if (countryAcronym && countryAcronym.toUpperCase() !== 'ND') {
    return countryAcronym.toUpperCase();
  }

  // Registros antigos não armazenavam `ac`, mas a sigla já fazia parte do slug.
  const slug = String(place.slug || place.slugCity || '')
    .split(/[?#]/)[0]
    .replace(/\/+$/, '');
  const slugAcronym = slug.match(/-([a-z]{2,3})$/i);
  if (slugAcronym) {
    return slugAcronym[1].toUpperCase();
  }

  return uf;
}

function mapCityData(place) {

  let name;
  let type;

  if (place.city) {
    name = place.city;
    type = 'city'
  } else if (place.airport) {
    name = place.airport
    type = 'airport'
  } else {
    name = place.beach
    type = 'beach'
  }

    const uf = resolveLocationCode(place);
    const label = `${name} - ${uf}`;
    const slug = slugify(String(name)).replaceAll("-","").toLowerCase();
    const href = `${place[idKeyByType[type]]}/${slug}-${uf.toLowerCase()}`;
  return {
    cid: place.idcity,
    cloc: place.idlocale,
    label: label,
    cname: name,
    uf: place.uf,
    ac: place.ac || (String(place.uf || '').toUpperCase() === 'ND' ? uf : ''),
    country: place.country,
    iscap: place.capital,
    issea: place.seaside,
    istour: place.tourist,
    isagr: place.agricultural,
    clat: place.latitude,
    clon: place.longitude,
    slug: href
  };

}

function unmapCityData(mapped, type) {
  const resolvedCode = resolveLocationCode(mapped);
  const acronym = mapped.ac || (
    String(mapped.uf || '').toUpperCase() === 'ND' && resolvedCode !== 'ND'
      ? resolvedCode
      : ''
  );

  if (type === 'beach') {
    return {
      idcity: mapped.cid,
      idlocale: mapped.cloc,
      beach: mapped.cname,
      uf: mapped.uf,
      ac: acronym,
      country: mapped.country,
      seaside: true,
      latitude: mapped.clat,
      longitude: mapped.clon
    };
  }

  if (type === 'airport') {
    return {
      idcity: mapped.cid,
      idlocale: mapped.cloc,
      airport: mapped.cname,
      uf: mapped.uf,
      ac: acronym,
      country: mapped.country,
      latitude: mapped.clat,
      longitude: mapped.clon
    };
  }

  return {
    idcity: mapped.cid,
    idlocale: mapped.cloc,
    city: mapped.cname,
    uf: mapped.uf,
    ac: acronym,
    country: mapped.country,
    capital: mapped.iscap,
    seaside: mapped.issea,
    tourist: mapped.istour,
    agricultural: mapped.isagr,
    latitude: mapped.clat,
    longitude: mapped.clon
  };
}

const LocalStorageHelper = {
  set,
  get,
  append,
  remove,
  mapCityData,
  unmapCityData,
  resolveLocationCode
};

export default LocalStorageHelper;
